import './App.css';
import { Amplify } from 'aws-amplify';
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import config from './amplifyconfiguration.json';
import { BrowserRouter } from 'react-router-dom';
import PediPlayLayout from './Shared/UI/PediPlayLayout';
import { useEffect } from 'react';
import { fetchUserAttributes, fetchAuthSession } from 'aws-amplify/auth';
import { UserProvider } from './Shared/Contexts/UserContext';

Amplify.configure(config);


const App = ({ signOut, user }) => {

  return (
    <BrowserRouter>
      <UserProvider user={user}>
        <PediPlayLayout signOut={signOut} />
      </UserProvider>
    </BrowserRouter>
  )
}

export default withAuthenticator(App, {hideSignUp: true});
